import * as React from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Chip from '@mui/material/Chip';
import { useNavigate } from 'react-router-dom';

const columns = [
    
    { field: 'name', headerName: 'Name', width: 150 },
    { field: 'serviceCategoryName', headerName: 'Service Category', width: 150 },
    { field: 'price', headerName: 'Price', width: 150, sortable: false },
    { field: 'discountPercentage', headerName: 'Discount Percentage', width: 150, sortable: false },
    { field: 'serviceCharge', headerName: 'Service Charge', width: 150, sortable: false },
    {
        field: 'isActive',
        headerName: 'Status',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Active' : 'Inactive'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : '#cf0a0a', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },
    {
        field: 'isApproved',
        headerName: 'Approved',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Approved' : 'Pending'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : 'blue', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },
    {
        field: 'isFeatured',
        headerName: 'Featured',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Featured' : 'Basic'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? '#FFD700' : '#90CAF9', // Dynamic color
                        color: 'balck', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },
    {
        field: 'discounted',
        headerName: 'Discount',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                <Chip
                    label={params.value ? 'Discounted' : 'Not Discounted'}
                    style={{
                        backgroundColor: params.value ? '#FF4081' : '#E0E0E0',
                        color: 'white',
                        fontWeight: 'bold',
                    }}
                    size="small"
                />
            </div>
        ),
    },
    {
        field: 'homeServiceEnabled',
        headerName: 'Home Service',
        width: 180,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                <Chip
                    label={params.value ? 'Available' : 'Not Available'}
                    style={{
                        backgroundColor: params.value ? '#8BC34A' : '#E0E0E0',
                        color: 'white',
                        fontWeight: 'bold',
                    }}
                    size="small"
                />
            </div>
        ),
    }
];
// Add the 'Branches' column only if the user type is ADMIN
const userType = localStorage.getItem('userType');
if (userType === 'ADMIN') {
    columns.push({
        field: 'branches',
        headerName: 'Branches',
        width: 300,
        renderCell: (params) => {
            const branchNames = params.row.branch.map((b) => b.name).join(', ');
            return <span>{branchNames}</span>;
        },
    });
}
export default function ServiceTable() {

    const userType = localStorage.getItem('userType');
    const { service, partnerservice } = useServiceContext();
    var tableData;
    if (userType === 'ADMIN') {
        tableData = service;
    }
    else {
        tableData = partnerservice;
    }
    const navigate = useNavigate();
    const filterColumns = ({ field, columns, currentFilters }) => {
        // remove already filtered fields from list of columns
        const filteredFields = currentFilters?.map((item) => item.field);
        return columns
            .filter(
                (colDef) =>
                    colDef.filterable &&
                    (colDef.field === field || !filteredFields.includes(colDef.field)),
            )
            .map((column) => column.field);
    };

    const getColumnForNewFilter = ({ currentFilters, columns }) => {
        const filteredFields = currentFilters?.map(({ field }) => field);
        const columnForNewFilter = columns
            .filter(
                (colDef) => colDef.filterable && !filteredFields.includes(colDef.field),
            )
            .find((colDef) => colDef.filterOperators?.length);
        return columnForNewFilter?.field ?? null;
    };
    const CustomToolbar = (props) => (
        <GridToolbarContainer>
            {(userType === 'PARTNER') && <EditToolbar {...props} />}
            <GridToolbar />
        </GridToolbarContainer>
    );
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            handleAddBranch();

        };
        const handleAddBranch = () => {
            navigate('/addservice');
        };
        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    New Service
                </Button>
            </GridToolbarContainer>
        );
    }
    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        navigate(`/editpartnerservice/${params.id}/false`, { state: { service: params.row } });
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <DataGrid rows={tableData} columns={columns}
                slots={{ toolbar: CustomToolbar }}
                onRowClick={handleRowClick} // Add this line to handle row clicks
                slotProps={{
                    filterPanel: {
                        filterFormProps: {
                            filterColumns,
                        },
                        getColumnForNewFilter,
                    },
                }}
            />
        </div>
    );
}